import { Router, Route } from '../abstracts/Router';

export class WbKlaviyo extends Router {

  init() {
    this.routes = [
      new Route('Viewed Product', ['^/(produits|products)/[a-z0-9-%]+'], this.viewProduct.bind(this)),
      new Route('Viewed Event', ['^/(evenements|events)/[a-z0-9-%]+$'], this.viewEvent.bind(this)),
      new Route('Viewed Workshop', ['^/(formations|workshops)/[a-z0-9-%]+$'], this.viewWorkshop.bind(this)),
    ];
  }

  /**
   *
   * @returns {void}
   */
  viewProduct() {
    const element = document.querySelector('.wb-tab-panel:not([hidden]) [data-purchasable]');
    const item = JSON.parse(element.dataset.purchasable);

    window.klaviyo.push(['track', 'Viewed Product', {
      'ProductName': item.title,
      'ProductID': item.sku,
      'Price': item.price,
      'Category': item.type,
      'ImageURL': item.image,
      'URL': item.url,
    }]);
  }

  /**
   * @returns {void}
   */
  viewEvent() {
    const item = JSON.parse(document.querySelector('[data-event]').dataset.event);

    window.klaviyo.push(['track', 'Viewed Event', {
      'ProductName': item.title,
      'ProductID': item.sku,
      'Price': 'N/A',
      'Category': item.type,
      'ImageURL': item.image,
      'URL': item.url,
    }]);
  }

  /**
   * @returns {void}
   */
  viewWorkshop() {
    const item = JSON.parse(document.querySelector('[data-event]').dataset.event);

    window.klaviyo.push(['track', 'Viewed Workshop', {
      'ProductName': item.title,
      'ProductID': item.sku,
      'Price': 'N/A',
      'Category': item.type,
      'ImageURL': item.image,
      'URL': item.url,
    }]);
  }

  /**
   * Subscribe users
   * @param data
   * @returns {Promise<Response>}
   */
  async subscribe(data) {
    const session = await this.getSession();

    return fetch('/actions/klaviyoconnect/api/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': session.csrfTokenValue,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams(data),
    });
  }

  /**
   *
   * @returns {Promise<any>}
   */
  async getSession() {
    return fetch('/actions/users/session-info', {
      headers: {
        'Accept': 'application/json',
      },
    }).then(response => response.json());
  }
}